export default __webpack_public_path__ + "static/media/TractorSupplyAd.dd58a01e.png";